import { Button, Form, Input, message, Select, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { serverFetch } from "@/server";
import { ScanButton } from "@/extensions/design";
import { Scan } from "@/controls";

const Card = ({ id, vidId, vids, onClose, code }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      form.setFieldsValue({ code: code || "", name: "", vidId, comment: "" });
      return;
    }

    setLoading(true);
    serverFetch(`Card/${id}`)
      .then(data => {
        form.setFieldsValue(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }, [id, vidId, code, form]);

  const onSave = () => {
    form.validateFields().then(values => {
      const bodyData = {
        ...values,
        id: id ?? 0,
        code: values.code.trim(),
        name: values.name?.trim() || "",
        comment: values.comment?.trim() || null,
      };

      setLoading(true);
      serverFetch("Card", { method: id ? "PUT" : "POST", bodyData })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const vidOptions = vids.map(vid => ({ value: vid.id, label: vid.name }));

  const applyCode = useCallback(scannedCode => {
    const nextCode = scannedCode?.trim();
    if (!nextCode || loading) return;
    form.setFieldValue("code", nextCode);
  }, [form, loading]);

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" style={{ width: 560 }} onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Карта</span>
          <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} />
        </div>
        <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false} disabled={loading}>
          <Form.Item label="Код" required>
            <Space.Compact style={{ width: "100%" }}>
              <Form.Item name="code" noStyle rules={[{ required: true, message: "Введите код карты" }]}>
                <Input maxLength={64} />
              </Form.Item>
              <ScanButton title="Считайте карту" onScan={applyCode} disabled={loading} />
            </Space.Compact>
            {!loading && <Scan onScan={applyCode} />}
          </Form.Item>
          <Form.Item name="name" label="Наименование">
            <Input maxLength={120} />
          </Form.Item>
          <Form.Item name="vidId" label="Группа" rules={[{ required: true, message: "Выберите группу" }]}>
            <Select options={vidOptions} showSearch optionFilterProp="label" allowClear />
          </Form.Item>
          <Form.Item name="comment" label="Комментарий">
            <Input.TextArea maxLength={500} rows={3} />
          </Form.Item>
          <Form.Item label=" ">
            <Space>
              <Button type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
              <Button onClick={() => onClose(false)}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>;
};

export default Card;
